/**
  * 反馈模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const BaseFeedbackApi = {
    GetDataList: `${base.qa}/BaseFeedback/GetDataList`,
    DelData: `${base.qa}/BaseFeedback/DelData`,
}

const BaseFeedback = {
    GetDataList (pageindex, pagesize) {
        return axios.get(BaseFeedbackApi.GetDataList, { params: { pageindex, pagesize } })
    },
    DelData (params) {
        return axios.post(BaseFeedbackApi.DelData, params)
    },
}


export default BaseFeedback;